import { Dialog, DialogContent } from '@/components/atoms/Dialog';
import { Button } from '@/components/atoms/PcButton';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDelete?: () => void;
  isDeleting?: boolean;
}

const DiagnosisFailedDialog = ({ open, onOpenChange, onDelete, isDeleting }: Props) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        noCloseBtn
        className="flex w-[360px] flex-col items-center gap-[20px] p-[30px]"
      >
        <div className="flex w-full flex-col items-start gap-[4px]">
          <div className="text-gr-900 Title3S18">최적화 진단을 실패했어요</div>
          <div className="whitespace-pre-line text-left text-gr-700 Body5M14">
            {'일시적인 오류가 발생했습니다.\n잠시 후 다시 시도해주세요.'}
          </div>
        </div>
        <div className="flex w-full">
          <Button
            variant="muted"
            className="h-[48px] flex-1"
            onClick={onDelete}
            disabled={isDeleting || !onDelete}
          >
            진단 상품 삭제
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DiagnosisFailedDialog;
